import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, ButtonGroup, Button } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import TranslateObj from "../../../common/translation-object";
var RadioGroup = function RadioGroup(props) {
  var onChange = props.onChange,
    elements = props.elements,
    index = props.index;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var type = 'radio-group';
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center"
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    className: "CollectorQuestionResponseGrouped"
  }, elements.map(function (response) {
    var currentResponse = Collector.getQuestionResponseByKey(currentOrder, responses, response.alias, null, currentQuestion);
    var checked = currentResponse || false;
    return /*#__PURE__*/React.createElement(Button, {
      type: "button",
      color: "default",
      key: "radio_g_".concat(Math.random()),
      onClick: function onClick() {
        return onChange(response, !checked, type, index);
      },
      className: "radioGroup ".concat(checked ? 'active' : '')
    }, /*#__PURE__*/React.createElement(TranslateObj, {
      from: response.name
    }));
  }))));
};
RadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({}))
};
RadioGroup.defaultProps = {
  elements: []
};
export default RadioGroup;